import SEO from "../components/seo/SEO";
import Breadcrumbs from "../components/seo/Breadcrumbs";
import { CATEGORIES } from "../config/categories";
import { getCalculatorsByCategory } from "../config/calculators";
import CalculatorCard from "../components/calculator/CalculatorCard";
import { Icon } from "../components/common/Icon";

export default function CalculatorsIndex() {
  return (
    <>
      <SEO
        title="All Canadian Financial Calculators (2025) — MyFinancesGuru Tools"
        description="Every free Canadian financial calculator in one place: mortgage, TFSA, RRSP, FHSA, RESP, GIC, retirement, debt payoff, budget, net worth and more."
        path="/calculators"
        keywords={["canadian financial calculators list", "free finance calculators canada"]}
      />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Calculators", to: "/calculators" }]} />
        <h1 className="font-heading text-4xl font-bold tracking-tight text-foreground sm:text-5xl">All calculators</h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">15 free, Canada-specific tools. Pick one to get an instant, plain-language answer.</p>

        <div className="mt-14 space-y-16">
          {CATEGORIES.map((cat) => (
            <section key={cat.id} id={cat.id}>
              <div className="mb-6 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/10 text-brand"><Icon name={cat.icon} className="h-5 w-5" /></span>
                <div>
                  <h2 className="font-heading text-2xl font-bold text-foreground">{cat.name}</h2>
                  <p className="text-sm text-muted-foreground">{cat.description}</p>
                </div>
              </div>
              <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {getCalculatorsByCategory(cat.id).map((c) => <CalculatorCard key={c.slug} calc={c} />)}
              </div>
            </section>
          ))}
        </div>
      </div>
    </>
  );
}
